module.exports = __webpack_public_path__ + "img/type_ICE.6dbda2f2.png";